import { get } from 'lodash';
import APIClient from '../../../../common/services/APIClient';
import { CHARGER_ONLINE_NO, CHARGER_ONLINE_YES } from '../../../../common/constants/statuses';

export const fetchEdgeControllersData = async () => {
  try {
    const [coreDevicesResp, customersResp, plazasResp] = await Promise.all([
      APIClient.get('/plazas/core-devices'),
      APIClient.get('/users/me/customer').catch(() => ({ data: {} })),
      APIClient.get('/plazas', {
        params: { page_token: 0, page_size: 999 },
      }).catch(() => ({ data: { payloads: [] } })),
    ]);

    const coreDevices = Array.isArray(coreDevicesResp.data) ? coreDevicesResp.data : [];
    const customer = get(customersResp, 'data', {});
    const deviceIds = coreDevices.map(({ device_id }) => device_id);
    const plazas = get(plazasResp, 'data.payloads', []);

    const releasesResponse = await APIClient.get('/plazas/core-devices/releases', {
      params: { controllerIds: deviceIds.join(',') },
    }).catch(() => ({ data: { releases: [] } }));

    const releases = get(releasesResponse, 'data.releases') || [];
    const customerMap = { [customer.customerId]: customer.customerName };
    const releasesMap = Object.fromEntries(releases?.map(({ controllerId, lastReleaseName }) => [controllerId, lastReleaseName]));
    const componentVersionsMap = Object.fromEntries(
      releases?.map(({ controllerId, componentVersions }) => [controllerId, componentVersions || {}]),
    );
    const plazaNamesMap = Object.fromEntries(plazas?.map(({ uuid, name }) => [uuid, name]));

    return coreDevices.map((device) => ({
      ...device,
      plaza_name: plazaNamesMap[device.plaza_id] || '',
      uuid: device.device_id,
      online: device.online ? CHARGER_ONLINE_YES : CHARGER_ONLINE_NO,
      customerName: customerMap[device.customer_id] || device.customer_id || '',
      firmwareVersion: releasesMap[device.device_id] || '',
      componentVersions: componentVersionsMap[device.device_id] || {},
    }));
  } catch (error) {
    console.log('Api error ', error);
    throw new Error(`Api error: ${error}`);
  }
};
